import * as classnames from 'classnames'
import * as React from 'react'
import {Link, LinkProps} from 'react-router-dom'
import * as classNames from './plain-link.css'

export class PlainLink extends React.PureComponent<LinkProps, {}> {
  public render() {
    return (
      <Link {...this.props} className={classnames(classNames.link, this.props.className)} />
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/link/plain-link.tsx